import {Switch} from '@headlessui/react'

export interface SliderToggleProps {
    enabled: boolean
    setEnabled: (enabled: boolean) => void
}

export function SliderToggle(props: SliderToggleProps) {
    return (
        <div className="h-full">
            <Switch
                checked={props.enabled}
                onChange={props.setEnabled}
                className={`${props.enabled ? 'bg-[#69A61C]' : 'bg-gray-1'}
                            relative flex h-full w-full border-2 border-[transparent] rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none`}
            >
                <span className="sr-only">Use setting</span>
                <span
                    aria-hidden="true"
                    className={`${props.enabled ? 'translate-x-[80%]' : 'translate-x-0'}
                                pointer-events-none inline-block h-[98%] w-[55%] rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200`}
                />
            </Switch>
        </div>
    )
}
